import type { ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

export interface ConnectorStatusBadgeProps {
  isConnected: boolean
  className?: string
}

/**
 * Displays a connection status badge with visual indicator.
 * Shows "Connected" in green or "Not connected" in muted style.
 */
export const ConnectorStatusBadge = ({
  isConnected,
  className,
}: ConnectorStatusBadgeProps): ReactNode => (
  <Badge
    variant="outline"
    className={cn(
      'connector-status-badge',
      isConnected
        ? 'border-green-300 bg-green-50 text-green-700 dark:border-green-700 dark:bg-green-900/30 dark:text-green-400'
        : 'border-muted text-muted-foreground',
      className
    )}
  >
    {isConnected ? 'Connected' : 'Not connected'}
  </Badge>
)

ConnectorStatusBadge.displayName = 'ConnectorStatusBadge'
